import React from "react"
import {
  zoneLibre,
  zoneLibreTitle,
  zoneLibreIndex,
} from "./contenu-libre.module.scss"
import {
  masonryGrid,
  masonryGridColumn,
  galerieContainer,
  galerieItemContainer,
  galerieItemHeader,
  galerieItemLink,
  galerieItemDescription,
} from "../Home/GalerieImages/galerie-images.module.scss"
import Teleformulaire from "../Teleformulaire/teleformulaire"
import ContentTransformer from "../Transformers/content-transformer"
import PropTypes from "prop-types"
import { useBuildData } from "../../hooks/use-build-data"
import { Title, ZoneLibre } from "./contenu-libre-styled"
import { useContenuLibre } from "./contenu-libre-query"
import FinalGalerieComponent from "../Home/GalerieImages/final-galerie-component"
import TransitionFade from "../transition-fade"
import Masonry from "react-masonry-css"
import { summaryLength } from "../../constants/index"
import SummaryTransformer from "../Transformers/summary-transformer"
import { breakpointColumnsObj } from "../Home/GalerieImages/galerie-breakpoints"
import { GalerieItemContainer } from "../Home/GalerieImages/galerie-images-styled"
import EditButton from "../EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ContenuLibre = ({ zoneTaxoLibre, isIndex }) => {
  const buildColors = useBuildData().theme_settings.palette
  const data = useContenuLibre()
  const contenusLibre = data.allNodeContenuLibre.edges
  const teleformulaires = data.allNodeTeleformulaires.edges
  const galerie = data.allNodeGalerieDImages.edges
  const resultTeleform = teleformulaires
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const resultContenuLibre = contenusLibre
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const resultGalerie = galerie
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const bothNodes = [resultTeleform, resultContenuLibre, resultGalerie]
  const result = bothNodes
    .sort((firstDate, lastDate) => {
      if (firstDate.node.created > lastDate.node.created) return -1
      if (firstDate.node.created < lastDate.node.created) return 1
      return 0
    })
    .shift()
  if (!result) return null
  let zoneLibreColor = "white"
  let zoneLibreClassName = zoneLibre
  if (isIndex) {
    zoneLibreClassName = zoneLibreIndex
    zoneLibreColor = buildColors.a_color_gradients.a_light
    if (zoneTaxoLibre === "zone_accueil_2") {
      zoneLibreColor += "B3"
    }
  }
  let contentZoneLibre = (
    <Teleformulaire zoneLibre={true} teleform={result.node} />
  )
  if (result.node.internal.type === "node__contenu_libre") {
    contentZoneLibre = (
      <>
        <Title className={zoneLibreTitle}>{result.node.title}</Title>
        <ContentTransformer content={result.node.body?.processed} />
      </>
    )
  }
  if (result.node.internal.type === "node__galerie_d_images") {
    contentZoneLibre = (
      <>
        <Title className={zoneLibreTitle}>{result.node.title}</Title>
        <GalerieItemContainer className={galerieContainer}>
          <FinalGalerieComponent zoneLibre={true} data={result.node}>
            {({ images }) => (
              <div className={galerieItemContainer}>
                <div className={galerieItemHeader}>
                  <div className={galerieItemDescription}>
                    {result.node.body && (
                      <p
                        style={{ marginBottom: "0" }}
                        dangerouslySetInnerHTML={{
                          __html: SummaryTransformer(
                            result.node.body,
                            summaryLength
                          ),
                        }}
                      />
                    )}
                  </div>
                  <div className={galerieItemLink}>
                    <TransitionFade
                      className="btn"
                      link={result.node.path.alias}
                    >
                      Voir l&apos;intégralité de la galerie
                    </TransitionFade>
                  </div>
                </div>
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className={masonryGrid}
                  columnClassName={masonryGridColumn}
                >
                  {images}
                </Masonry>
              </div>
            )}
          </FinalGalerieComponent>
        </GalerieItemContainer>
      </>
    )
  }
  return (
    <ZoneLibre
      bgColor={zoneLibreColor}
      isIndex={isIndex}
      className={zoneLibreClassName}
    >
      <EditButton
        link={"/node/" + result.node.drupal_internal__nid + "/edit"}
      />
      {contentZoneLibre}
    </ZoneLibre>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

ContenuLibre.propTypes = {
  zoneTaxoLibre: PropTypes.string.isRequired,
  isIndex: PropTypes.bool,
}
//-----------------------Prop-Types---------------------------//

export default ContenuLibre
